import { render, staticRenderFns } from "./ShippingInfo.vue?vue&type=template&id=349ded14&scoped=true"
import script from "./ShippingInfo.vue?vue&type=script&lang=js"
export * from "./ShippingInfo.vue?vue&type=script&lang=js"
import style0 from "./ShippingInfo.vue?vue&type=style&index=0&id=349ded14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349ded14",
  null
  
)

export default component.exports